/* unplugin-vue-components disabled */import { render } from "./genrate-textarea.vue?vue&type=template&id=8a1bfd74&scoped=true"
import script from "./genrate-textarea.vue?vue&type=script&lang=js"
export * from "./genrate-textarea.vue?vue&type=script&lang=js"

import "./genrate-textarea.vue?vue&type=style&index=0&id=8a1bfd74&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1bfd74"],['__file',"src/components/genrate/genrate-textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a1bfd74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a1bfd74', __exports__)) {
    api.reload('8a1bfd74', __exports__)
  }
  
  module.hot.accept("./genrate-textarea.vue?vue&type=template&id=8a1bfd74&scoped=true", () => {
    api.rerender('8a1bfd74', render)
  })

}


export default __exports__